class CommutingController {

    constructor() {
        this.model = plannerApplication.studyPlannerProfile.getCommuting();
        this.view = new CommutingView(
            this.onSelectOption.bind(this),
            this.onChangeDuration.bind(this),
        );

        let thisObj = this;
        this.model.getCommutingOptions().each(function(commuteOption){
           thisObj.view.options[commuteOption.getName()].update(commuteOption.isSelected(), commuteOption.getDuration());
        });
    }

    onSelectOption(optionName, isSelected) {
        this.model.getCommutingOptionFor(optionName).setSelected(isSelected);
        plannerApplication.userDataUpdated();
    }

    onChangeDuration(optionName, duration) {
        this.model.getCommutingOptionFor(optionName).setDuration(duration);
        plannerApplication.userDataUpdated();
    }
}
